import React, { useContext, useEffect, useState } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import { putData } from "../../../utils/api";
import {
  ErrorManagement,
  FieldFormComponents,
  FormManagement,
} from "../../../utils/FormComponents/FormComponents";
import { HTTPS } from "../../../utils/https-status-codes";

const PASSWORD_REGEX = /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;

// Add (editId = 0) and Edit (editId = user id) form for one role's staff.
const StaffForm = ({ editId, handleClose, show }) => {
  const { postData, getData } = useContext(Context);
  const [showModal, setShowModal] = useState({ code: 0, message: "" });
  const isEdit = !!editId;

  const {
    register,
    handleSubmit,
    reset,
    setError,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (!isEdit) return;
    (async () => {
      const response = await getData(
        `/admin/employee-management/supervisor/${editId}`,
      );
      if (response?.success) {
        reset({
          employee_id: response.data?.employee_id || "",
          name: response.data?.name,
          contact_no: response.data?.contact_no,
          email: response.data?.email,
        });
      }
    })();
  }, [editId]);

  const onSubmit = async (data) => {
    try {
      const sendData = await FormManagement(data);

      const response = isEdit
        ? await putData(
            `/admin/employee-management/supervisor/${editId}`,
            sendData,
          )
        : await postData(`/admin/employee-management/supervisor`, sendData);

      if (response?.success) {
        setShowModal({
          code: response.code,
          message: response?.data,
          // message: isEdit ? "Updated Successfully" : "Created Successfully",
        });
        setTimeout(() => {
          setShowModal({ code: 0, message: "" });
          handleClose();
        }, 3000);
      } else if (response.code === HTTPS.UNPROCESSABLE_ENTITY.code) {
        ErrorManagement(setError, response?.errors || {});
      } else {
        setShowModal({ code: response?.code, message: response?.errors });
      }
      setTimeout(() => {
        setShowModal({ code: 0, message: "" });
      }, 3000);
    } catch (error) {
      setShowModal({ code: error?.code || 404, message: error?.message });
      setTimeout(() => {
        setShowModal({ code: 0, message: "" });
      }, 3000);
    }
  };

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {isEdit ? "Edit" : "Add"} Supervisor
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={(e) => e.preventDefault()} role="form">
            <Row>
              {isEdit && (
                <FieldFormComponents label="Employee ID">
                  <Form.Control
                    type="text"
                    disabled
                    {...register("employee_id")}
                  />
                </FieldFormComponents>
              )}
              <FieldFormComponents label="Full Name" error={errors.name}>
                <Form.Control
                  type="text"
                  placeholder="Full name"
                  className={classNames("", { "is-invalid": errors?.name })}
                  {...register("name", {
                    required: "Full Name is required",
                    maxLength: { value: 200, message: "Max 200 characters" },
                  })}
                />
              </FieldFormComponents>
              <FieldFormComponents label="Contact No" error={errors.contact_no}>
                <Form.Control
                  type="text"
                  placeholder="Contact No"
                  maxLength={10}
                  className={classNames("", {
                    "is-invalid": errors?.contact_no,
                  })}
                  {...register("contact_no", {
                    required: "Contact No is required",
                  })}
                  onKeyPress={(e) => {
                    if (!/[0-9]/.test(e.key)) e.preventDefault();
                  }}
                />
              </FieldFormComponents>
              <FieldFormComponents label="Login Email" error={errors.email}>
                <Form.Control
                  type="text"
                  placeholder="Email"
                  className={classNames("", { "is-invalid": errors?.email })}
                  {...register("email", {
                    required: "Email is required",
                    pattern: {
                      value: /^[A-Za-z0-9_\-.]+@[A-Za-z0-9\-.]+\.[A-Za-z]{2,}$/,
                      message: "Invalid Email address",
                    },
                  })}
                  onKeyDown={(e) => {
                    if (e.key === " ") e.preventDefault();
                  }}
                />
              </FieldFormComponents>
              <FieldFormComponents
                label={
                  isEdit
                    ? "New Password (leave blank to keep)"
                    : "Login Password"
                }
                error={errors.password}
              >
                <Form.Control
                  type="text"
                  placeholder="Login Password"
                  className={classNames("", {
                    "is-invalid": errors?.password,
                  })}
                  {...register("password", {
                    required: isEdit ? false : "Login Password is required",
                    validate: (v) =>
                      !v ||
                      PASSWORD_REGEX.test(v) ||
                      "Min 8 characters with an uppercase letter, a number and a symbol.",
                  })}
                />
              </FieldFormComponents>
            </Row>
            <Row className="mt-5 pb-3">
              <div className="d-flex justify-content-center">
                <Link>
                  <CancelButton name={"cancel"} handleClose={handleClose} />
                </Link>
                <SaveButton
                  name={"save"}
                  handleSubmit={handleSubmit(onSubmit)}
                />
              </div>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default StaffForm;
